


























































































































































































































































































































































































































import { Component, Vue, Ref, Watch, Prop } from 'vue-property-decorator';
import { State, Getter } from 'vuex-class';
import ProjectCard from '@/components/projectcard/projectcard.component.vue';
import ProjectModal from '@/components/projectmodal/projectmodal.component.vue';
import { Camera } from '@/models/camera';
import { City } from '@/models/city';
import { Project } from '@/models/project';
import { User } from '@/models/user';
// @ts-ignore: no d.ts file
import { vTeleport } from '@desislavsd/vue-teleport';
import * as Plotly from 'plotly.js';
import { ModeBarDefaultButtons } from 'plotly.js';
import { Storage } from 'aws-amplify';
import { Logger } from 'aws-amplify';
import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css'; // Re-uses images from ~leaflet package
import 'leaflet-defaulticon-compatibility';
import * as L from 'leaflet';
import Shepherd from 'shepherd.js';
import 'shepherd.js/dist/css/shepherd.css';
import { offset } from '@floating-ui/dom';
import { title } from 'process';

enum SortType {
  Recent = 'recent',
  City = 'city',
}

enum FilterType {
  All = 'all',
  Active = 'active',
  Inactive = 'inactive',
  NoPhoto48 = 'noPhoto48',
}

type LeafletIcon = ReturnType<typeof L.icon>;
type LeafletBounds = ReturnType<typeof L.latLngBounds>;

@Component({
  components: {
    ProjectCard,
    ProjectModal,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    vTeleport,
  },
})
export default class ProjectList extends Vue {
  @Ref('project-modal') readonly projectModal!: ProjectModal;
  @Prop({ type: String, default: null }) readonly logoUrl!: string | null;
  @State('user', { namespace: 'profile' }) private user!: User;

  @State('projects', { namespace: 'projects' }) private allProject!: Project[];
  // @Getter('filter', { namespace: 'projects' }) private filterProject!: (search: string) => Project[];

  private projects: Project[] = [];
  private search = '';
  private displayedProjectsCount = 20; // Nombre initial de projets à afficher

  private url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
  private attribution = '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
  private center: [number, number] = [48.858093, 2.294694]; // Coordinates for Paris, France
  private zoom = 4;
  private showMap = false; // Set to true to display the map by default
  private showMosaicAndList = true;
  private satelliteView = false;
  private mapButtonText = 'Map';
  private cardsPerRow = this.calculateCardsPerRow();
  public imageUrls: { [key: string]: string } = {};
  private imagesLoaded = 0;
  private readonly FilterType = FilterType;
  private filter: FilterType = FilterType.All;
  public defaultImageUrl = 'https://via.placeholder.com/150';
  private selectedOwner: string | null = null;
  public showGraph = false;
  private showTypeFilter = false;
  private selectedTypes: string[] = ['Tout', 'IA', 'Live'];
  private oldSelected: string[] = [];
  private windowWidth: number = window.innerWidth;
  private intervalId: ReturnType<typeof setInterval> | null = null;
  private resetTrigger = 0;
  private updateKey = 0;
  private mapBounds: LeafletBounds | null = null;
  private normalize(v?: string | null) {
    return (v ?? '').toLowerCase().trim();
  }
  private looksLikeEmail(q: string) {
    return this.normalize(q).includes('@');
  }

  private readonly ACTIVE_COLORS = { base: '#051e37', light: '#1a456f' }; // bleu
  private readonly DONE_COLORS = { base: '#9AA3AD', light: '#C7CDD3' }; // gris

  private iconCache: Record<string, LeafletIcon> = {};

  private selectedProjectId: string | null = null;

  private sidebarDisplayedCount = 5;
  private readonly SIDEBAR_PAGE = 5;
  private sidebarIo?: IntersectionObserver;
  private hoveredProjectId: string | null = null;
  private readonly FADE_OPACITY = 0.2;
  private readonly HOVER_Z = 10000;
  private hoverTimeout: ReturnType<typeof setTimeout> | null = null;
  private closeTimeout: ReturnType<typeof setTimeout> | null = null;

  private isPointerOverMarker = false;
  private isPointerOverPopup = false;

  private customZoom?: ReturnType<typeof L.control.zoom>;
  private addCustomZoom() {
    const mapRef: any = this.$refs.map;
    const map = mapRef?.mapObject || mapRef;
    if (!map) return;

    // retire l’ancien si on remonte la carte
    this.customZoom?.remove();

    this.customZoom = L.control
      .zoom({
        position: 'topright', // ⬅️ haut-droite
        zoomInText: '<span aria-hidden="true">+</span>',
        zoomOutText: '<span aria-hidden="true">−</span>',
        zoomInTitle: (this.$t('gallery.zoomin') as string) || 'Zoom in',
        zoomOutTitle: (this.$t('gallery.zoomout') as string) || 'Zoom out',
      })
      .addTo(map);
  }

  private get isErigeStaff(): boolean {
    const u = this.user as any;
    if (!u || !u.id) return false;
    return ['d71996b1-800f-4ec8-8f20-c1a341198f62', '5a308ace-0010-404d-9b75-b68d60cf0526'].includes(u.id);
  }

  private get markerProjects(): Project[] {
    const base = this.projects; // déjà filtré par updateProjectsAndMap()
    if (this.hoveredProjectId) return base.filter((p) => p.id === this.hoveredProjectId);
    return base;
  }

  private onSidebarHover(project: Project) {
    this.hoveredProjectId = project.id;
  }

  private onSidebarLeave() {
    this.hoveredProjectId = null;
  }

  private markerOpacity(p: Project): number {
    if (!this.hoveredProjectId) return 1;
    return p.id === this.hoveredProjectId ? 1 : this.FADE_OPACITY;
  }

  private markerZIndex(p: Project): number {
    // top si survolé ; sinon, si “sélectionné” (popup/clic), on le met juste en dessous
    if (this.hoveredProjectId === p.id) return this.HOVER_Z;
    if (this.selectedProjectId === p.id) return this.HOVER_Z - 1;
    return 0; // z-index normal
  }

  private onMarkerOver(project: Project) {
    this.isPointerOverMarker = true;
    this.hoveredProjectId = project.id;

    if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
    this.hoverTimeout = setTimeout(() => {
      if (this.hoveredProjectId === project.id) {
        this.showPopup(project);
      }
    }, 120); // petit délai anti-clignotement
  }

  private onMarkerOut() {
    this.isPointerOverMarker = false;
    this.hoveredProjectId = null;
    this.scheduleCloseIfNoHover();
  }

  private onPopupEnter() {
    this.isPointerOverPopup = true;
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
  }

  private onPopupLeave() {
    this.isPointerOverPopup = false;
    this.scheduleCloseIfNoHover();
  }

  private scheduleCloseIfNoHover() {
    if (this.closeTimeout) clearTimeout(this.closeTimeout);
    this.closeTimeout = setTimeout(() => {
      if (!this.isPointerOverMarker && !this.isPointerOverPopup) {
        const mapRef: any = this.$refs.map;
        const map = mapRef?.mapObject || mapRef;
        map?.closePopup?.();
        this.selectedProjectId = null;
      }
    }, 160); // grâce pour laisser le temps d’entrer dans le popup
  }

  // Tri commun à la mosaïque : createdAt DESC
  private get sortedProjectsForSidebar(): Project[] {
    return [...this.projectsForViewportAndFilters].sort(
      (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
  }

  // Fenêtre paginée utilisée par la sidebar
  private get sidebarProjects(): Project[] {
    return this.sortedProjectsForSidebar.slice(0, this.sidebarDisplayedCount);
  }

  // Choix de l'icône selon le statut, avec cache
  private getMarkerIcon(p: Project): LeafletIcon {
    const completed = p.status === 'Terminé';
    const key = completed ? 'completed-dim' : 'active';

    if (this.iconCache[key]) return this.iconCache[key];

    const colors = completed ? this.DONE_COLORS : this.ACTIVE_COLORS;
    const icon = this.makePinIcon(colors.base, colors.light, { dim: completed });
    this.iconCache[key] = icon;
    return icon;
  }

  private initSidebarIO() {
    this.destroySidebarIO();

    const root = this.$refs.mapSidebar as HTMLElement | undefined;
    const sentinel = this.$refs.sidebarSentinel as HTMLElement | undefined;
    if (!root || !sentinel) return;

    this.sidebarIo = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            this.sidebarDisplayedCount = Math.min(
              this.sidebarDisplayedCount + this.SIDEBAR_PAGE,
              this.projectsForViewportAndFilters.length
            );
          }
        }
      },
      { root, rootMargin: '400px 0px', threshold: 0.01 }
    );

    this.sidebarIo.observe(sentinel);
    this.$nextTick(() => this.topUpIfShort());
  }

  private destroySidebarIO() {
    if (this.sidebarIo) {
      this.sidebarIo.disconnect();
      this.sidebarIo = undefined;
    }
  }

  /** Si le contenu est plus petit que la hauteur visible, on ajoute des pages jusqu’à remplir. */
  private topUpIfShort() {
    const root = this.$refs.mapSidebar as HTMLElement | undefined;
    if (!root) return;
    while (
      root.scrollHeight <= root.clientHeight &&
      this.sidebarDisplayedCount < this.projectsForViewportAndFilters.length
    ) {
      this.sidebarDisplayedCount = Math.min(
        this.sidebarDisplayedCount + this.SIDEBAR_PAGE,
        this.projectsForViewportAndFilters.length
      );
    }
  }

  /** Réinitialise la fenêtre quand les filtres changent fortement. */
  private resetSidebarList() {
    this.sidebarDisplayedCount = Math.min(this.SIDEBAR_PAGE, this.projectsForViewportAndFilters.length);
    this.$nextTick(() => this.initSidebarIO());
  }

  // Générateur d'icône SVG (sans rond blanc) + "dim" pour terminé
  private makePinIcon(base: string, light: string, opts: { dim?: boolean } = {}): LeafletIcon {
    const opacity = opts.dim ? 0.65 : 1; // transparence douce pour Terminé
    const strokeOpacity = opts.dim ? 0.7 : 1; // bord légèrement atténué
    const shadowOpacity = opts.dim ? 0.18 : 0.3; // halo plus discret quand terminé

    const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="72" viewBox="0 0 52 72">
      <defs>
        <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="2" stdDeviation="2" flood-opacity="${shadowOpacity}"/>
        </filter>
        <linearGradient id="g" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"  stop-color="${light}" stop-opacity="${opacity}"/>
          <stop offset="100%" stop-color="${base}"  stop-opacity="${opacity}"/>
        </linearGradient>
      </defs>
      <!-- forme du pin (pas de disque blanc) -->
      <path filter="url(#shadow)"
        d="M26 69 C26 69 6 47 6 36 A20 20 0 1 1 46 36 C46 47 26 69 26 69 Z"
        fill="url(#g)" stroke="rgba(255,255,255,${strokeOpacity})" stroke-width="2"/>
    </svg>`.trim();

    const url = 'data:image/svg+xml;utf8,' + encodeURIComponent(svg);
    return L.icon({
      iconUrl: url,
      iconSize: [28, 44],
      iconAnchor: [14, 42],
      popupAnchor: [0, -36],
      className: 'fancy-pin',
    });
  }

  public get owners(): User[] {
    const ownerMap = new Map<string, User>();

    this.allProject.forEach((project) => {
      // Accéder au propriétaire de chaque projet
      const owner = project.owner;
      if (owner && owner.id && !ownerMap.has(owner.id)) {
        const fullOwner: User = {
          ...owner,
          createdAt: new Date(), // Remplacez par une valeur valide si nécessaire
          firstLogin: false, // Ajoutez des valeurs par défaut
          birthday: undefined,
          company: undefined,
          function: undefined,
          acceptedCgu: false,
          acceptedNewslettre: false,
          notification: false,
          locale: owner.locale,
          volumeData: undefined,
        };
        ownerMap.set(owner.id, fullOwner);
      }
    });

    return Array.from(ownerMap.values());
  }

  private get iaProjectCount(): number {
    return this.allProject.filter((project) => project.cameras?.some((cam) => cam.detectionia === true)).length;
  }

  private get liveProjectCount(): number {
    return this.allProject.filter((project) => project.cameras?.some((cam) => cam.live === true)).length;
  }

  private get toutProjectCount(): number {
    return this.allProject.filter(
      (project) => !project.cameras?.some((cam) => cam.detectionia === true || cam.live === true)
    ).length;
  }

  private get displayedProjectsForList(): Project[] {
    const sorted = [...this.projects].sort((a: any, b: any) => {
      const ta = this.toDate(a.createdAt)?.getTime() ?? 0;
      const tb = this.toDate(b.createdAt)?.getTime() ?? 0;
      return tb - ta; // DESC = plus récents d'abord
    });

    return sorted.slice(0, this.displayedProjectsCount);
  }

  public get visibleActiveCamerasCount(): number {
    return this.projects.filter((p) => p.status !== 'Terminé').reduce((sum, p) => sum + (p.cameras?.length ?? 0), 0);
  }

  public get visibleCamerasCount(): number {
    return this.projectsForViewportAndFilters.reduce((sum, p) => sum + (p.cameras?.length ?? 0), 0);
  }

  private get projectsForViewportAndFilters(): Project[] {
    // Tous les filtres globaux sont déjà appliqués dans this.projects
    let base = this.projects;

    // Restreindre au viewport si la carte est visible
    if (this.showMap && this.mapBounds) {
      base = base.filter((p) => this.mapBounds!.contains(L.latLng(p.city.latlng.lat, p.city.latlng.lng)));
    }

    return base; // ❌ pas de filtre "Terminé" ici
  }

  public get visibleProjectsCount(): number {
    return this.projectsForViewportAndFilters.length;
  }

  private onMapViewportChange() {
    const mapRef: any = this.$refs.map;
    const map = mapRef?.mapObject || mapRef;
    if (map && typeof map.getBounds === 'function') {
      this.mapBounds = map.getBounds();
    }
    // Si le viewport filtre fortement, on ajuste la fenêtre courante
    this.sidebarDisplayedCount = Math.min(this.sidebarDisplayedCount, this.projectsForViewportAndFilters.length);
    this.$nextTick(() => this.topUpIfShort());
  }

  private fitToCurrentProjects() {
    if (!this.showMap || this.projects.length === 0) return;

    const bounds = L.latLngBounds(
      this.projects.map((p) => [p.city.latlng.lat, p.city.latlng.lng] as [number, number])
    ).pad(0.1);

    const mapRef: any = this.$refs.map;
    const map = mapRef?.mapObject || mapRef;

    this.center = [bounds.getCenter().lat, bounds.getCenter().lng];
    this.mapBounds = bounds; // 🔑 garde les bounds à jour pour tes compteurs

    if (map && typeof map.fitBounds === 'function') {
      map.fitBounds(bounds);
    }
  }

  /* masaïc view variable */
  private readonly SortType = SortType;
  private sort: SortType = SortType.Recent;

  private nowTick = Date.now();
  private progressTickId: ReturnType<typeof setInterval> | null = null;

  /* list view variable */
  private fields = [
    { key: 'createdAt', label: "Date d'installation", sortable: true },
    { key: 'endDate', label: 'Date de Fin', sortable: true },
    { key: 'progressPercent', label: 'Avancement', sortable: true, thStyle: { width: '180px' } },
    { key: 'name', label: 'Nom du projet', sortable: true },
    { key: 'lastPhotoDate', label: 'Date de la dernière photo', sortable: true, thStyle: { width: '280px' } },
    { key: 'status', label: 'Statut', sortable: true, thStyle: { width: '100px' } },
    {
      key: 'city',
      label: 'Nom de la ville',
      formatter: (value: City) => value.value,
      sortable: true,
      sortByFormatted: true,
      thStyle: { width: '300px' },
    },
    {
      key: 'administrator',
      label: 'Administrateur',
      formatter: (value?: User[]) => (value ? value.length : 0),
      sortable: true,
      sortByFormatted: true,
    },
    {
      key: 'guest',
      label: 'Invités',
      formatter: (value?: User[]) => (value ? value.length : 0),
      sortable: true,
      sortByFormatted: true,
      thStyle: { width: '100px' },
    },
    {
      key: 'cameras',
      label: 'Caméras',
      formatter: (value?: Camera[]) => (value ? value.length : 0),
      sortable: true,
      sortByFormatted: true,
      thStyle: { width: '100px' },
    },
    { key: 'id', label: 'Réglages', thStyle: { width: '100px' } },
  ];

  private sortBy = 'createdAt';
  private sortDesc = true;

  private resetDisplayedProjectsCount(): void {
    this.displayedProjectsCount = 20;
  }

  private parseDate(input: any): Date | null {
    if (!input) return null;

    if (input instanceof Date) {
      return Number.isNaN(input.getTime()) ? null : input;
    }

    if (typeof input === 'string') {
      const s = input.trim();

      // Format DD/MM/YYYY (avec espaces optionnels)
      const m = s.match(/^(\d{2})\s*\/\s*(\d{2})\s*\/\s*(\d{4})/);
      if (m) {
        const dd = Number(m[1]);
        const mm = Number(m[2]);
        const yyyy = Number(m[3]);
        const d = new Date(yyyy, mm - 1, dd);
        return Number.isNaN(d.getTime()) ? null : d;
      }

      // ISO / autres formats parseables
      const d = new Date(s);
      return Number.isNaN(d.getTime()) ? null : d;
    }

    const d = new Date(input);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  private computeProgressPercent(project: Project): number | null {
    if (project.status === 'Terminé') return 100;

    const start = this.toDate((project as any).createdAt);
    const end = this.toDate((project as any).endDate);
    if (!start || !end) return null;

    const startMs = start.getTime();
    const endMs = end.getTime();
    const nowMs = Date.now();

    if (endMs <= startMs) return nowMs >= endMs ? 100 : 0;

    const ratio = (nowMs - startMs) / (endMs - startMs);
    return Math.round(Math.min(1, Math.max(0, ratio)) * 100);
  }

  private onFilterStatusChange() {
    this.updateProjectsAndMap();
    if (this.showMap) this.resetSidebarList();
  }

  private projectMatchesSearch(p: Project, raw: string): boolean {
    const q = this.normalize(raw);
    if (!q) return true;

    // Champs texte "classiques"
    const nameHit = this.normalize(p.name).includes(q);
    const tagHit = (p.tags ?? []).some((t) => this.normalize(t).includes(q));
    const cityHit =
      this.normalize((p.city as any)?.value)?.includes(q) || this.normalize((p.city as any)?.name)?.includes(q); // selon ton modèle

    // Emails & noms - owner
    const ownerEmailHit = this.normalize(p.owner?.email).includes(q);
    const ownerNameHit = `${this.normalize(p.owner?.firstname)} ${this.normalize(p.owner?.lastname)}`.includes(q);

    // Emails/noms - administrateurs
    const adminEmailHit = (p.administrator ?? []).some((u) => this.normalize((u as any).email).includes(q));
    const adminNameHit = (p.administrator ?? []).some((u) =>
      `${this.normalize((u as any).firstname)} ${this.normalize((u as any).lastname)}`.includes(q)
    );

    // Emails/noms - invités
    const guestEmailHit = (p.guest ?? []).some((u) => this.normalize((u as any).email).includes(q));
    const guestNameHit = (p.guest ?? []).some((u) =>
      `${this.normalize((u as any).firstname)} ${this.normalize((u as any).lastname)}`.includes(q)
    );

    // Emails - camera.owner (au cas où)
    const cameraOwnerEmailHit = (p.cameras ?? []).some((c) => this.normalize((c as any).owner?.email).includes(q));

    // Si la requête ressemble à un email, on privilégie les champs email.
    if (this.looksLikeEmail(q)) {
      return ownerEmailHit || adminEmailHit || guestEmailHit || cameraOwnerEmailHit;
    }

    // Sinon, recherche globale classique
    return (
      nameHit ||
      tagHit ||
      cityHit ||
      ownerEmailHit ||
      ownerNameHit ||
      adminEmailHit ||
      adminNameHit ||
      guestEmailHit ||
      guestNameHit ||
      cameraOwnerEmailHit
    );
  }

  private onFilterChangeStatus(value: FilterType) {
    if (value === FilterType.All) {
      this.projects = this.allProject.slice(0);
    } else if (value === FilterType.Active) {
      this.projects = this.allProject.filter((project) =>
        project.cameras.some((camera) => camera.apiFetchInterval !== -1)
      );
    } else if (value === FilterType.Inactive) {
      this.projects = this.allProject.filter((project) =>
        project.cameras.every(
          (camera) => camera.apiFetchInterval === -1 && camera.optic !== '4624x3472' && camera.optic !== '5496x3672'
        )
      );
    } else if (value === FilterType.NoPhoto48) {
      const threshold = Date.now() - 48 * 60 * 60 * 1000; // 48 heures en millisecondes
      this.projects = this.allProject.filter(
        (project) =>
          project.status !== 'Terminé' && // Le projet ne doit pas être terminé
          project.cameras.some((camera) => {
            // Vérifier que la caméra possède une dernière photo et que celle-ci est plus ancienne que 48 heures
            if (!camera.lastPhoto?.createdAt || new Date(camera.lastPhoto.createdAt).getTime() >= threshold) {
              return false;
            }
            // La caméra doit répondre à l'une des conditions suivantes :
            // - apiFetchInterval différent de -1
            // - optic égal à "4624x3472" ou "5496x3672"
            return camera.apiFetchInterval !== -1 || camera.optic === '4624x3472' || camera.optic === '5496x3672';
          })
      );
    }
    this.onSortChange(this.sort);
    this.resetDisplayedProjectsCount();
  }

  private onSelectedTypesChange(newVal: string[]): void {
    // Autoriser que la liste soit vide => pas de projet
    // si vous préférez forcer au moins 1, il faudrait un petit contrôle

    // On met simplement à jour
    this.selectedTypes = newVal;
    this.oldSelected = [...newVal];
    this.resetDisplayedProjectsCount();
    this.updateProjectsAndMap();
  }

  private handleClickOutside(event: MouseEvent): void {
    const dropdown = this.$refs.typeFilterDropdown as HTMLElement;
    if (dropdown && !dropdown.contains(event.target as Node)) {
      this.showTypeFilter = false; // Ferme le menu si le clic est à l'extérieur
    }
  }

  private toggleTypeFilter(): void {
    this.showTypeFilter = !this.showTypeFilter;
    if (this.showTypeFilter) {
      // Ajouter un écouteur de clic global lorsqu'on ouvre le menu
      document.addEventListener('click', this.handleClickOutside);
    } else {
      // Supprimer l'écouteur si le menu est fermé
      document.removeEventListener('click', this.handleClickOutside);
    }
  }

  private get displayedProjects(): Project[] {
    // Référence à resetTrigger pour forcer le recalcul à chaque mise à jour
    this.resetTrigger;

    // Si aucun type n'est sélectionné, retourner un tableau vide
    if (this.selectedTypes.length === 0) {
      return [];
    }

    // Commencer avec une nouvelle référence de this.projects pour garantir la réactivité
    let filteredProjects = [...this.projects];

    // Filtrer par statut (actif ou terminé)
    if (this.filterStatus === 'active') {
      filteredProjects = filteredProjects.filter((p) => p.status !== 'Terminé');
    } else if (this.filterStatus === 'completed') {
      filteredProjects = filteredProjects.filter((p) => p.status === 'Terminé');
    }

    // Filtrer par propriétaire sélectionné
    if (this.selectedOwner) {
      if (this.selectedOwner === 'others') {
        const excludedIds = [
          'd71996b1-800f-4ec8-8f20-c1a341198f62',
          '5a308ace-0010-404d-9b75-b68d60cf0526',
          '2048cf37-41ca-4b54-8bee-66d963d57f98',
          'f55592f0-cda7-4243-8fc5-add96d5d53db',
        ];
        filteredProjects = filteredProjects.filter(
          (project) => project.owner && !excludedIds.includes(project.owner.id)
        );
      } else {
        filteredProjects = filteredProjects.filter((project) => project.owner?.id === this.selectedOwner);
      }
    }

    // Filtrer par recherche (nom, tags, propriétaire)
    if (this.search) {
      filteredProjects = filteredProjects.filter((p) => this.projectMatchesSearch(p, this.search));
    }

    // Filtrer par types sélectionnés (Tout, IA, Live)
    const hasIA = this.selectedTypes.includes('IA');
    const hasLive = this.selectedTypes.includes('Live');
    const hasTout = this.selectedTypes.includes('Tout');
    const countSelected = [hasTout, hasIA, hasLive].filter(Boolean).length;

    if (countSelected === 3) {
      // Tous les projets (Tout + IA + Live)
    } else if (countSelected === 1 && hasTout) {
      // Projets sans IA ni Live
      filteredProjects = filteredProjects.filter(
        (project) => !project.cameras?.some((cam) => cam.detectionia === true || cam.live === true)
      );
    } else if (countSelected === 1 && hasIA) {
      // Projets avec au moins une caméra IA
      filteredProjects = filteredProjects.filter((project) => project.cameras?.some((cam) => cam.detectionia === true));
    } else if (countSelected === 1 && hasLive) {
      // Projets avec au moins une caméra Live
      filteredProjects = filteredProjects.filter((project) => project.cameras?.some((cam) => cam.live === true));
    } else if (countSelected === 2 && hasIA && hasLive) {
      // Projets avec au moins une caméra IA et une caméra Live
      filteredProjects = filteredProjects.filter((project) => {
        const hasIaCam = project.cameras?.some((cam) => cam.detectionia === true);
        const hasLiveCam = project.cameras?.some((cam) => cam.live === true);
        return hasIaCam && hasLiveCam;
      });
    } else if (countSelected === 2 && hasTout && hasLive) {
      // Projets sans IA
      filteredProjects = filteredProjects.filter(
        (project) => !project.cameras?.some((cam) => cam.detectionia === true)
      );
    } else if (countSelected === 2 && hasTout && hasIA) {
      // Projets sans Live
      filteredProjects = filteredProjects.filter((project) => !project.cameras?.some((cam) => cam.live === true));
    } else {
      // Aucun projet si aucune case n'est cochée
      return [];
    }

    // Trier les projets par date de création (les plus récents en premier)
    filteredProjects.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

    // Limiter le nombre de projets affichés avec lazy loading
    return filteredProjects.slice(0, this.displayedProjectsCount);
  }

  private filterStatus = 'all'; // Valeur par défaut : afficher tous les projets

  public get filteredProjects(): Project[] {
    let filtered = this.allProject;

    if (this.filterStatus === 'active') {
      filtered = filtered.filter((project) => project.status === 'En cours');
    } else if (this.filterStatus === 'completed') {
      filtered = filtered.filter((project) => project.status === 'Terminé');
    }

    return filtered.filter((project) => this.projectMatchesSearch(project, this.search));
  }

  public get activeProjectsCount(): number {
    return this.allProject.filter((project) => project.status === 'En cours').length;
  }

  public get inactiveProjectsCount(): number {
    const threshold = Date.now() - 48 * 60 * 60 * 1000; // 48 heures en millisecondes
    return this.allProject.filter(
      (project) =>
        project.status !== 'Terminé' && // Exclure les projets terminés
        project.cameras.every(
          (camera) => camera.apiFetchInterval === -1 && camera.optic !== '4624x3472' && camera.optic !== '5496x3672'
        ) &&
        project.cameras.some(
          (camera) =>
            camera.lastPhoto?.createdAt
              ? new Date(camera.lastPhoto.createdAt).getTime() < threshold // Dernière photo plus vieille que 48h
              : true // Si pas de dernière photo, considérer comme inactif
        )
    ).length;
  }

  public get completedProjectsCount(): number {
    return this.allProject.filter((project) => project.status === 'Terminé').length;
  }

  public get activeProjects(): number {
    const completedProjects = this.allProject.filter((project) => project.status === 'Terminé').length;
    return this.allProject.length - completedProjects;
  }

  public get defectiveProjectsCount(): number {
    const threshold = Date.now() - 48 * 60 * 60 * 1000; // 48 heures en millisecondes
    return this.allProject.filter(
      (project) =>
        project.status !== 'Terminé' && // Le projet ne doit pas être terminé
        project.cameras.some((camera) => {
          // Vérifier que la caméra possède une dernière photo et que celle-ci est plus ancienne que 48 heures
          if (!camera.lastPhoto?.createdAt || new Date(camera.lastPhoto.createdAt).getTime() >= threshold) {
            return false;
          }
          // La caméra doit répondre à l'une des conditions suivantes :
          // - apiFetchInterval différent de -1
          // - optic égal à "4624x3472" ou "5496x3672"
          return camera.apiFetchInterval !== -1 || camera.optic === '4624x3472' || camera.optic === '5496x3672';
        })
    ).length;
  }

  public get totalProjects(): number {
    return this.allProject.length;
  }

  public get projectsByMonth() {
    const months = ['Jan', 'Fév', 'Mars', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Dec'];

    const dates = this.allProject.map((project) => new Date(project.createdAt));
    const projectsByMonth: { [key: string]: number } = {};
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();

    const camerasByMonth: { [key: string]: number } = {};
    this.allProject.forEach((project) => {
      if (project.id !== '0ec8c17e-b539-4762-8d71-d33f34a12aa0') {
        const projectDate = new Date(project.createdAt);
        const key = `${projectDate.getFullYear()}-${projectDate.getMonth()}`;
        const camerasCount = project.cameras?.length || 0; // Nombre de caméras pour ce projet
        camerasByMonth[key] = (camerasByMonth[key] || 0) + camerasCount;
      }
    });

    for (let i = currentMonth - 1; i <= currentMonth; i++) {
      const key = `${currentYear}-${i}`;
      if (!projectsByMonth[key]) {
        projectsByMonth[key] = 0; // Pas de projets, mais inclure le mois
      }
    }

    dates.forEach((date) => {
      const key = `${date.getFullYear()}-${date.getMonth()}`;
      projectsByMonth[key] = (projectsByMonth[key] || 0) + 1;
    });

    const sortedKeys = Object.keys(projectsByMonth).sort((a, b) => {
      const [yearA, monthA] = a.split('-').map(Number);
      const [yearB, monthB] = b.split('-').map(Number);
      return yearA !== yearB ? yearA - yearB : monthA - monthB;
    });
    let cumulativeCount = 0;
    const cumulativeData = sortedKeys.map((key) => {
      cumulativeCount += projectsByMonth[key];
      return { key, count: projectsByMonth[key], cumulative: cumulativeCount };
    });

    const cumulativeCamerasData: number[] = [];
    let cumulativeCamerasCount = 0;

    sortedKeys.forEach((key) => {
      cumulativeCamerasCount += camerasByMonth[key] || 0;
      cumulativeCamerasData.push(cumulativeCamerasCount);
    });

    const labels = cumulativeData.map((item) => {
      const [year, month] = item.key.split('-').map(Number);
      return `${months[month]} ${year}`;
    });

    const counts = cumulativeData.map((item) => item.count);
    const cumulatives = cumulativeData.map((item) => item.cumulative);
    const camerasCounts = sortedKeys.map((key) => camerasByMonth[key] || 0);

    return { labels, counts, cumulatives, camerasCounts, cumulativeCamerasData };
  }

  private get projectsForCounter(): Project[] {
    // Base = tous les filtres déjà appliqués (owner, status, types, search, FilterType…)
    let base = this.projects;

    // Si la carte est affichée et qu'on a des bounds, on restreint au viewport
    if (this.showMap && this.mapBounds) {
      base = base.filter((p) => {
        const { lat, lng } = p.city.latlng;
        return this.mapBounds!.contains(L.latLng(lat, lng));
      });
    }

    // Si tu veux exclure "Terminé" quand filterStatus !== 'completed'
    if (this.filterStatus !== 'completed') {
      base = base.filter((p) => p.status !== 'Terminé');
    }

    return base;
  }

  private toggleGraph(): void {
    // Inverse la valeur de showGraph
    this.showGraph = !this.showGraph;

    // Si on vient de l'activer
    if (this.showGraph) {
      this.$nextTick(() => {
        this.renderGraph();
      });
    }
  }

  private renderGraph(): void {
    const { labels, counts, cumulatives, camerasCounts, cumulativeCamerasData } = this.projectsByMonth;

    const data: Plotly.Data[] = [
      {
        x: labels,
        y: counts,
        type: 'bar',
        name: 'Nombre de projets par mois',
        marker: {
          color: '#5fc9e4',
        },
        yaxis: 'y2', // Axe gauche (par mois)
      },
      {
        x: labels,
        y: camerasCounts,
        type: 'bar',
        name: 'Nombre de caméras par mois',
        marker: { color: '#4dffcd' },
        yaxis: 'y2',
      },
      {
        x: labels,
        y: cumulatives,
        type: 'scatter',
        mode: 'lines+markers',
        name: 'Cumul des projets',
        line: { color: '#5fc9e4' },
        yaxis: 'y', // Axe droit (cumul)
      },
      {
        x: labels,
        y: cumulativeCamerasData,
        type: 'scatter',
        mode: 'lines+markers',
        name: 'Cumul des caméras',
        line: { color: '#4dffcd', dash: 'dot' },
        yaxis: 'y',
      },
    ];

    const layout: Partial<Plotly.Layout> = {
      titlefont: { color: '#5fc9e4' },
      // un peu plus de marge en haut pour loger les boutons
      margin: { t: 80, r: 50, l: 50, b: 40 },

      xaxis: {
        title: { text: 'Mois', font: { color: '#5fc9e4' } },
        gridcolor: '#314a644a',
        linecolor: '#314a644a',
        color: '#5fc9e4',
        range: [0, labels.length - 0.2],
      },
      yaxis: {
        title: { text: 'Cumul des projets / caméras', font: { color: '#5fc9e4' } },
        gridcolor: '#314a644a',
        side: 'right',
        color: '#5fc9e4',
        range: [0, Math.max(...cumulatives, ...cumulativeCamerasData)],
      },
      yaxis2: {
        title: { text: 'Nombre par mois', font: { color: '#4dffcd' } },
        overlaying: 'y',
        side: 'left',
        showgrid: false,
        color: '#4dffcd',
        range: [0, Math.max(...counts, ...camerasCounts)],
      },
      legend: {
        orientation: 'h',
        x: 0,
        y: 1.15,
      },
      barmode: 'group',
      paper_bgcolor: 'rgba(0,0,0,0)',
      plot_bgcolor: 'rgba(0,0,0,0)',

      // 🔘 Boutons dans l'en-tête du graphique
      updatemenus: [
        {
          type: 'buttons',
          direction: 'right',
          x: 0.5,
          xanchor: 'center',
          y: 1.25,
          yanchor: 'top',
          showactive: true,
          bgcolor: 'rgba(0, 19, 38, 0.85)',
          bordercolor: '#5fc9e4',
          borderwidth: 1,
          pad: { r: 10, l: 10, t: 4, b: 4 },
          font: { color: '#5fc9e4', size: 12 },

          buttons: [
            {
              label: 'Histogrammes',
              method: 'restyle',
              // on ne touche qu’aux traces 0 et 1 (projets/mois & caméras/mois)
              args: [
                {
                  type: 'bar',
                  'marker.color': ['#5fc9e4', '#4dffcd'],
                },
                [0, 1],
              ],
            },
            {
              label: 'Courbes',
              method: 'restyle',
              args: [
                {
                  type: 'scatter',
                  mode: 'lines+markers',
                  'marker.color': ['#5fc9e4', '#4dffcd'],
                  'line.color': ['#5fc9e4', '#4dffcd'],
                },
                [0, 1],
              ],
            },
          ],
        },
      ] as any,
    };

    const config: Partial<Plotly.Config> = {
      responsive: true,
      displaylogo: false,
    };

    Plotly.newPlot('project-graph', data, layout as any, config as any);
  }

  private loadMoreProjects(): void {
    this.displayedProjectsCount += 2; // Charger 20 projets supplémentaires
  }

  private checkScroll(): void {
    const threshold = 100; // 100 pixels avant d'atteindre le bas
    const position = window.innerHeight + window.scrollY;
    const height = document.body.offsetHeight;

    if (position >= height - threshold) {
      this.loadMoreProjects();
    }
  }

  private onOwnerChange(selectedOwnerId: string | null) {
    this.selectedOwner = selectedOwnerId;
    this.displayedProjectsCount = 20;
    this.updateProjectsAndMap();
    if (this.showMap) this.resetSidebarList();
  }

  private calculateCardsPerRow(): number {
    let windowWidth = window.innerWidth;

    if (windowWidth <= 800) {
      // pour écrans xs
      return 1;
    } else if (windowWidth <= 1000) {
      // pour écrans sm
      return 2;
    } else if (windowWidth <= 1500) {
      // pour écrans md
      return 3;
    } else if (windowWidth <= 2500) {
      // pour écrans md
      return 4;
    } else {
      // pour écrans lg et plus
      return 5;
    }
  }

  private onFilterChange(value: FilterType) {
    if (value === FilterType.All) {
      this.projects = this.allProject.slice(0);
    } else if (value === FilterType.Active) {
      this.projects = this.allProject.filter((project) =>
        project.cameras.some((camera) => camera.apiFetchInterval !== -1)
      );
    } else if (value === FilterType.Inactive) {
      this.projects = this.allProject.filter((project) =>
        project.cameras.every((camera) => camera.apiFetchInterval === -1)
      );
    } else if (value === FilterType.NoPhoto48) {
      const threshold = Date.now() - 48 * 60 * 60 * 1000; // 48 hours ago
      this.projects = this.allProject.filter((project) =>
        project.cameras.some((camera) => {
          if (camera.apiFetchInterval !== -1 && camera.lastPhoto?.createdAt) {
            return new Date(camera.lastPhoto.createdAt).getTime() < threshold;
          } else {
            return false; // or true, depending on your logic
          }
        })
      );
    }
    this.onSortChange(this.sort);
  }

  private mounted() {
    window.addEventListener('resize', this.handleResize);
    this.oldSelected = [...this.selectedTypes];
    window.addEventListener('scroll', this.checkScroll);
    this.onSearchChange();
    this.calculateMapBounds();
    this.$nextTick(() => this.onMapViewportChange());
    this.updateProjectsAndMap();
    window.addEventListener('resize', () => {
      this.cardsPerRow = this.calculateCardsPerRow();
    });
    this.$nextTick(() => {
      setTimeout(() => {
        if (localStorage.getItem('tourIgnored')) {
          return;
        }
        if (window.innerWidth >= 700) {
          const tour = new Shepherd.Tour({
            defaultStepOptions: {
              cancelIcon: {
                enabled: true,
              },
              classes: 'shepherd-content', // Ajoutez votre propre classe CSS
              scrollTo: true,
              when: {
                show() {
                  const currentStep = Shepherd.activeTour?.getCurrentStep();
                  if (!currentStep) return;
                  const currentStepElement = currentStep.getElement();
                  if (!currentStepElement) return;
                  const header = currentStepElement.querySelector('.shepherd-footer');
                  if (!header) return;
                  const progress = document.createElement('div');
                  const innerBar = document.createElement('span');
                  const progressPercentage = ((tour.steps.indexOf(currentStep) + 1) / tour.steps.length) * 100 + '%';
                  progress.className = 'shepherd-progress-bar';
                  innerBar.style.width = progressPercentage;
                  if (document.getElementsByClassName('shepherd-button').length == 1) {
                    progress.style.minWidth = '260px';
                  }
                  progress.appendChild(innerBar);
                  const headerh = currentStepElement.querySelector('.shepherd-header');
                  const progressh = document.createElement('span');
                  progressh.style.marginRight = '0px';
                  progressh.innerText = `${tour.steps.indexOf(currentStep) + 1}/${tour.steps.length}`;
                  if (headerh) {
                    headerh.insertBefore(progressh, currentStepElement.querySelector('.shepherd-cancel-icon'));
                  }
                  header.insertBefore(progress, currentStepElement.querySelector('.shepherd-button'));
                },
              },
            },
            useModalOverlay: true,
            keyboardNavigation: false,
          });

          tour.addStep({
            title: this.$t('projectlist.step1title').toString(),
            text: this.$t('projectlist.step1text').toString(),
            attachTo: {
              element: 'nothing', // La classe CSS d  e l'élément que vous voulez souligner
              on: 'left',
            },
            buttons: [
              {
                action: () => {
                  localStorage.setItem('tourIgnored', 'true');
                  tour.complete();
                },
                text: this.$t('projectlist.donotshow').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
          });
          tour.addStep({
            title: this.$t('projectlist.step2title').toString(),
            text: this.$t('projectlist.step2text').toString(),
            attachTo: {
              element: 'nothing', // La classe CSS de l'élément que vous voulez souligner
              on: 'left',
            },
            buttons: [
              {
                action: () => {
                  localStorage.setItem('tourIgnored', 'true');
                  tour.complete();
                },
                text: this.$t('projectlist.donotshow').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
          });
          tour.addStep({
            title: this.$t('projectlist.step3title').toString(),
            text: this.$t('projectlist.step3text').toString(),
            attachTo: {
              element: '.searchproject', // La classe CSS de l'élément que vous voulez souligner
              on: 'bottom',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
            },
          });

          tour.addStep({
            title: this.$t('projectlist.step4title').toString(),
            text: this.$t('projectlist.step4text').toString(),
            attachTo: {
              element: '.diffvue', // La classe CSS de l'élément que vous voulez souligner
              on: 'bottom',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: function () {
                  let gripElement = document.querySelector('.fa-grip');
                  if (gripElement) {
                    (gripElement as HTMLElement).click();
                  }
                  setTimeout(function () {
                    tour.next();
                  }, 100);
                },
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 10, crossAxis: 0 })],
            },
          });
          tour.addStep({
            title: this.$t('projectlist.step5title').toString(),
            text: this.$t('projectlist.step5text').toString(),
            attachTo: {
              element: '.vuezoom', // La classe CSS de l'élément que vous voulez souligner
              on: 'bottom',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            advanceOn: { selector: '.vuemap', event: 'click' },
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 11, crossAxis: 0 })],
            },
          });
          tour.addStep({
            title: this.$t('projectlist.step6title').toString(),
            text: this.$t('projectlist.step6text').toString(),
            attachTo: {
              element: '.projetcarte', // La classe CSS de l'élément que vous voulez souligner
              on: 'bottom',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
            },
            scrollTo: false,
          });
          tour.addStep({
            title: this.$t('projectlist.step61title').toString(),
            text: this.$t('projectlist.step61text').toString(),
            attachTo: {
              element: '.invite', // La classe CSS de l'élément que vous voulez souligner
              on: 'bottom',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            advanceOn: { selector: '.picto-settings', event: 'click' },
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
            },
            scrollTo: false,
          });
          tour.addStep({
            title: this.$t('projectlist.step62title').toString(),
            text: this.$t('projectlist.step62text').toString(),
            attachTo: {
              element: '.picto-settings', // La classe CSS de l'élément que vous voulez souligner
              on: 'right',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: function () {
                  // Aller directement à l'étape 10 (index 9)
                  tour.show(11);
                },
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            advanceOn: { selector: '.picto-settings', event: 'click' },
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
            },
            scrollTo: false,
          });
          tour.addStep({
            title: this.$t('projectlist.step7title').toString(),
            text: this.$t('projectlist.step7text').toString(),
            attachTo: {
              element: '.description', // La classe CSS de l'élément que vous voulez souligner
              on: 'bottom',
            },
            buttons: [
              {
                action: function () {
                  // Déclenche un clic sur l'élément de classe '.close'
                  let closeElement = document.querySelector('.close');
                  if (closeElement) {
                    (closeElement as HTMLElement).click();
                  }
                  tour.back();
                },
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            advanceOn: { selector: '.picto-settings', event: 'click' },
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 70, crossAxis: 0 })],
            },
            scrollTo: false,
          });
          tour.addStep({
            title: this.$t('projectlist.step8title').toString(),
            text: this.$t('projectlist.step8text').toString(),
            attachTo: {
              element: '.col-12', // La classe CSS de l'élément que vous voulez souligner
              on: 'top',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            advanceOn: { selector: '.picto-settings', event: 'click' },
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 10, crossAxis: 0 })],
            },
            scrollTo: false,
          });
          tour.addStep({
            title: this.$t('projectlist.step9title').toString(),
            text: this.$t('projectlist.step9text').toString(),
            attachTo: {
              element: '.iframe', // La classe CSS de l'élément que vous voulez souligner
              on: 'left',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: function () {
                  // Déclenche un clic sur l'élément de classe '.close'
                  let closeElement = document.querySelector('.close');
                  if (closeElement) {
                    (closeElement as HTMLElement).click();
                  }
                  tour.next();
                },
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            advanceOn: { selector: '.picto-settings', event: 'click' },
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 10, crossAxis: 0 })],
            },
            scrollTo: false,
          });
          tour.addStep({
            title: this.$t('projectlist.step10title').toString(),
            text: this.$t('projectlist.step10text').toString(),
            attachTo: {
              element: '.projetcarte', // La classe CSS de l'élément que vous voulez souligner
              on: 'right',
            },
            buttons: [
              {
                action: function () {
                  // Aller directement à l'étape 10 (index 9)
                  tour.show(6);
                },
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: () => {
                  localStorage.setItem('tourIgnored', 'true');
                  tour.complete();
                },
                text: this.$t('projectlist.donotshow').toString(),
                classes: 'shepherd-button-ignore',
              },
            ],
            advanceOn: { selector: '.projetcarte', event: 'click' },
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 10, crossAxis: 0 })],
            },
            scrollTo: false,
          });
          if (!window.location.pathname.endsWith('/login')) {
            tour.start();
          }
        }
      }, 2000);
    });
    this.intervalId = setInterval(() => {
      this.fetchProjects(); // mise à jour des projets sans recharger toute la page
    }, 300000); // 5 minutes
    if (this.showMap) {
      this.$nextTick(() => this.initSidebarIO());
    }
    this.$nextTick(() => {
      if (this.showMap) this.addCustomZoom();
    });

    this.progressTickId = setInterval(() => {
      this.nowTick = Date.now();
    }, 60_000);
  }

  private handleResize(): void {
    this.windowWidth = window.innerWidth;
  }

  private get projectsWithLastPhotoDate(): Project[] {
    return this.displayedProjectsForList.map((project) => {
      let latestDate: Date | null = null;

      project.cameras.forEach((camera) => {
        if (camera.lastPhoto && camera.lastPhoto.createdAt) {
          const photoDate =
            camera.lastPhoto.createdAt instanceof Date
              ? camera.lastPhoto.createdAt
              : new Date(camera.lastPhoto.createdAt);

          if (!latestDate || photoDate > latestDate) {
            latestDate = photoDate;
          }
        }
      });

      const progressPercent = this.computeProgressPercent(project);

      return {
        ...project,
        lastPhotoDate: latestDate ? latestDate : 'Pas de photo',
        progressPercent, // ✅ pour la colonne Avancement
      } as any;
    });
  }

  get searchLabel(): string {
    // Vous devez définir la clé 'projectlist.searchMobile' dans vos fichiers de traduction
    return this.windowWidth < 600
      ? this.$t('projectlist.searchMobile').toString()
      : this.$t('projectlist.search').toString();
  }

  public startTour(): void {
    const tour = new Shepherd.Tour({
      defaultStepOptions: {
        cancelIcon: {
          enabled: true,
        },
        classes: 'shepherd-content', // Ajoutez votre propre classe CSS
        scrollTo: true,
        when: {
          show() {
            const currentStep = Shepherd.activeTour?.getCurrentStep();
            if (!currentStep) return;
            const currentStepElement = currentStep.getElement();
            if (!currentStepElement) return;
            const header = currentStepElement.querySelector('.shepherd-footer');
            if (!header) return;
            const progress = document.createElement('div');
            const innerBar = document.createElement('span');
            const progressPercentage = ((tour.steps.indexOf(currentStep) + 1) / tour.steps.length) * 100 + '%';
            progress.className = 'shepherd-progress-bar';
            innerBar.style.width = progressPercentage;
            if (document.getElementsByClassName('shepherd-button').length == 1) {
              progress.style.minWidth = '260px';
            }
            progress.appendChild(innerBar);
            const headerh = currentStepElement.querySelector('.shepherd-header');
            const progressh = document.createElement('span');
            progressh.style.marginRight = '0px';
            progressh.innerText = `${tour.steps.indexOf(currentStep) + 1}/${tour.steps.length}`;
            if (headerh) {
              headerh.insertBefore(progressh, currentStepElement.querySelector('.shepherd-cancel-icon'));
            }
            header.insertBefore(progress, currentStepElement.querySelector('.shepherd-button'));
          },
        },
      },
      useModalOverlay: true,
      keyboardNavigation: false,
    });

    tour.addStep({
      title: this.$t('projectlist.step1title').toString(),
      text: this.$t('projectlist.step1text').toString(),
      attachTo: {
        element: 'nothing', // La classe CSS d  e l'élément que vous voulez souligner
        on: 'left',
      },
      buttons: [
        {
          action: () => {
            localStorage.setItem('tourIgnored', 'true');
            tour.complete();
          },
          text: this.$t('projectlist.donotshow').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
    });
    tour.addStep({
      title: this.$t('projectlist.step2title').toString(),
      text: this.$t('projectlist.step2text').toString(),
      attachTo: {
        element: 'nothing', // La classe CSS de l'élément que vous voulez souligner
        on: 'left',
      },
      buttons: [
        {
          action: () => {
            localStorage.setItem('tourIgnored', 'true');
            tour.complete();
          },
          text: this.$t('projectlist.donotshow').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
    });
    tour.addStep({
      title: this.$t('projectlist.step3title').toString(),
      text: this.$t('projectlist.step3text').toString(),
      attachTo: {
        element: '.searchproject', // La classe CSS de l'élément que vous voulez souligner
        on: 'bottom',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
      },
    });

    tour.addStep({
      title: this.$t('projectlist.step4title').toString(),
      text: this.$t('projectlist.step4text').toString(),
      attachTo: {
        element: '.diffvue', // La classe CSS de l'élément que vous voulez souligner
        on: 'bottom',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: function () {
            let gripElement = document.querySelector('.fa-grip');
            if (gripElement) {
              (gripElement as HTMLElement).click();
            }
            setTimeout(function () {
              tour.next();
            }, 100);
          },
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 10, crossAxis: 0 })],
      },
    });
    tour.addStep({
      title: this.$t('projectlist.step5title').toString(),
      text: this.$t('projectlist.step5text').toString(),
      attachTo: {
        element: '.vuezoom', // La classe CSS de l'élément que vous voulez souligner
        on: 'bottom',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      advanceOn: { selector: '.vuemap', event: 'click' },
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 11, crossAxis: 0 })],
      },
    });
    tour.addStep({
      title: this.$t('projectlist.step6title').toString(),
      text: this.$t('projectlist.step6text').toString(),
      attachTo: {
        element: '.projetcarte', // La classe CSS de l'élément que vous voulez souligner
        on: 'bottom',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
      },
      scrollTo: false,
    });
    tour.addStep({
      title: this.$t('projectlist.step61title').toString(),
      text: this.$t('projectlist.step61text').toString(),
      attachTo: {
        element: '.invite', // La classe CSS de l'élément que vous voulez souligner
        on: 'bottom',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      advanceOn: { selector: '.picto-settings', event: 'click' },
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
      },
      scrollTo: false,
    });
    tour.addStep({
      title: this.$t('projectlist.step62title').toString(),
      text: this.$t('projectlist.step62text').toString(),
      attachTo: {
        element: '.picto-settings', // La classe CSS de l'élément que vous voulez souligner
        on: 'right',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: function () {
            // Aller directement à l'étape 10 (index 9)
            tour.show(11);
          },
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      advanceOn: { selector: '.picto-settings', event: 'click' },
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
      },
      scrollTo: false,
    });
    tour.addStep({
      title: this.$t('projectlist.step7title').toString(),
      text: this.$t('projectlist.step7text').toString(),
      attachTo: {
        element: '.description', // La classe CSS de l'élément que vous voulez souligner
        on: 'bottom',
      },
      buttons: [
        {
          action: function () {
            // Déclenche un clic sur l'élément de classe '.close'
            let closeElement = document.querySelector('.close');
            if (closeElement) {
              (closeElement as HTMLElement).click();
            }
            tour.back();
          },
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      advanceOn: { selector: '.picto-settings', event: 'click' },
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 70, crossAxis: 0 })],
      },
      scrollTo: false,
    });
    tour.addStep({
      title: this.$t('projectlist.step8title').toString(),
      text: this.$t('projectlist.step8text').toString(),
      attachTo: {
        element: '.col-12', // La classe CSS de l'élément que vous voulez souligner
        on: 'top',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      advanceOn: { selector: '.picto-settings', event: 'click' },
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 10, crossAxis: 0 })],
      },
      scrollTo: false,
    });
    tour.addStep({
      title: this.$t('projectlist.step9title').toString(),
      text: this.$t('projectlist.step9text').toString(),
      attachTo: {
        element: '.iframe', // La classe CSS de l'élément que vous voulez souligner
        on: 'left',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: function () {
            // Déclenche un clic sur l'élément de classe '.close'
            let closeElement = document.querySelector('.close');
            if (closeElement) {
              (closeElement as HTMLElement).click();
            }
            tour.next();
          },
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      advanceOn: { selector: '.picto-settings', event: 'click' },
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 10, crossAxis: 0 })],
      },
      scrollTo: false,
    });
    tour.addStep({
      title: this.$t('projectlist.step10title').toString(),
      text: this.$t('projectlist.step10text').toString(),
      attachTo: {
        element: '.projetcarte', // La classe CSS de l'élément que vous voulez souligner
        on: 'right',
      },
      buttons: [
        {
          action: function () {
            // Aller directement à l'étape 10 (index 9)
            tour.show(6);
          },
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: () => {
            localStorage.setItem('tourIgnored', 'true');
            tour.complete();
          },
          text: this.$t('projectlist.donotshow').toString(),
          classes: 'shepherd-button-ignore',
        },
      ],
      advanceOn: { selector: '.projetcarte', event: 'click' },
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 10, crossAxis: 0 })],
      },
      scrollTo: false,
    });
    tour.start();
  }

  public showPopup(project: Project) {
    this.preloadImages()
      .then(() => {
        this.loadImage(project);

        // 1) Récupérer le marker Leaflet
        const markerRef = this.$refs['marker-' + project.id] as any[] | any;
        const marker = Array.isArray(markerRef) ? markerRef[0]?.mapObject : markerRef?.mapObject;

        // 2) Fermer un éventuel popup déjà ouvert
        const mapRef: any = this.$refs.map;
        const map = mapRef?.mapObject || mapRef;
        if (map && typeof map.closePopup === 'function') map.closePopup();

        // 3) Ouvrir le popup lié à ce marker
        if (marker && typeof marker.openPopup === 'function') {
          marker.openPopup();
        }

        // 4) sync UI (sélection + scroll de la carte correspondante)
        this.selectedProjectId = project.id;
        this.$nextTick(() => {
          const refEl = this.$refs['card-' + project.id] as HTMLElement[] | HTMLElement | undefined;
          const el = Array.isArray(refEl) ? refEl[0] : refEl;
          el?.scrollIntoView?.({ block: 'center', behavior: 'smooth' });
        });
      })
      .catch((error) => {
        console.error('Erreur lors du préchargement des images:', error);
      });
  }

  public async preloadImages(): Promise<void[]> {
    const imagePromises: Promise<void>[] = [];
    for (const projectId in this.imageUrls) {
      const imageUrl = this.imageUrls[projectId];
      const imagePromise = new Promise<void>((resolve, reject) => {
        const image = new Image();
        image.onload = () => resolve();
        image.onerror = () => reject(new Error(`Erreur de chargement de l'image ${imageUrl}`));
        image.src = imageUrl;
      });
      imagePromises.push(imagePromise);
    }
    try {
      return await Promise.all(imagePromises);
    } catch (error) {
      console.error('Erreur lors du préchargement des images:', error);
      throw error; // Nous lançons l'erreur à nouveau pour que la fonction appelante puisse la gérer si nécessaire
    }
  }

  public loadImage(project: Project) {
    if (project.lastPhoto?.smallKey && !this.imageUrls[project.id]) {
      const key = project.lastPhoto.smallKey;
      Storage.get(key).then((url) => {
        this.$set(this.imageUrls, project.id, url) as string;
      });
    } else if (this.imageUrls[project.id]) {
      console.log(`L'image pour le projet ${project.id} est déjà chargée: ${this.imageUrls[project.id]}`); // Ajout d'un log si l'image est déjà chargée
    } else {
      console.log(`Aucune image à charger pour le projet ${project.id}`); // Ajout d'un log si il n'y a pas d'image à charger
    }
  }

  beforeDestroy() {
    // Enlever l'écouteur d'événement au moment de la destruction du composant
    window.removeEventListener('scroll', this.checkScroll);
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('resize', () => {
      this.cardsPerRow = this.calculateCardsPerRow();
    });
    document.removeEventListener('click', this.handleClickOutside);
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.destroySidebarIO();
    if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
    if (this.closeTimeout) clearTimeout(this.closeTimeout);
    if (this.progressTickId) clearInterval(this.progressTickId);
  }

  private async fetchProjects() {
    try {
      await this.$store.dispatch('projects/loadProject');
      const updatedProjects = [...this.$store.state.projects.projects];
      this.projects = updatedProjects;
      this.updateProjectsAndMap();
      this.updateKey++; // Incrémenter à chaque mise à jour
    } catch (error) {
      console.error('Erreur lors du chargement des projets:', error);
    }
  }

  private incrementCardsPerRow() {
    if (this.cardsPerRow < 6) {
      this.cardsPerRow++;
    }
  }

  private decrementCardsPerRow() {
    if (this.cardsPerRow > 1) {
      this.cardsPerRow--;
    }
  }

  public get breadcrumbs(): unknown[] {
    return [
      {
        text: this.$tc('global.project', 2),
        to: '#',
      },
    ];
  }

  public get listMode(): string | null {
    return (this.$route.query.listMode as string) || 'mosaic';
  }

  public set listMode(listMode: string | null) {
    if (listMode === null || listMode === 'mosaic') {
      this.$router.push({ path: this.$route.path, query: { ...this.$route.query, listMode: undefined } });
    } else {
      this.$router.push({ path: this.$route.path, query: { ...this.$route.query, listMode } });
    }
  }

  private formatDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // +1 car les mois vont de 0 à 11
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`;
  }

  private async updateProjectsAndMap(opts: { recenter?: boolean } = {}) {
    let updatedProjects: Project[] = [];

    // ⬇️ Filtre propriétaire (inchangé)
    if (this.selectedOwner) {
      if (this.selectedOwner === 'others') {
        const excludedIds = [
          'd71996b1-800f-4ec8-8f20-c1a341198f62',
          '5a308ace-0010-404d-9b75-b68d60cf0526',
          '2048cf37-41ca-4b54-8bee-66d963d57f98',
          'f55592f0-cda7-4243-8fc5-add96d5d53db',
        ];
        updatedProjects = this.allProject.filter((p) => p.owner && !excludedIds.includes(p.owner.id));
      } else {
        updatedProjects = this.allProject.filter((p) => p.owner && p.owner.id === this.selectedOwner);
      }
    } else {
      updatedProjects = [...this.allProject];
    }

    // 🔎 Recherche
    if (this.search) {
      updatedProjects = updatedProjects.filter((p) => this.projectMatchesSearch(p, this.search));
    }

    // ✅ Statut (Active/Completed/All)
    if (this.filterStatus === 'active') {
      updatedProjects = updatedProjects.filter((p) => p.status !== 'Terminé');
    } else if (this.filterStatus === 'completed') {
      updatedProjects = updatedProjects.filter((p) => p.status === 'Terminé');
    }

    // ✅ Type (Basic / IA / Live) — NOUVEAU pour synchroniser la carte
    updatedProjects = updatedProjects.filter((p) => this.projectMatchesSelectedTypes(p));

    if (this.filter === FilterType.Active) {
      updatedProjects = updatedProjects.filter((p) => p.cameras?.some((c) => c.apiFetchInterval !== -1));
    } else if (this.filter === FilterType.Inactive) {
      updatedProjects = updatedProjects.filter((p) =>
        p.cameras?.every((c) => c.apiFetchInterval === -1 && c.optic !== '4624x3472' && c.optic !== '5496x3672')
      );
    } else if (this.filter === FilterType.NoPhoto48) {
      const threshold = Date.now() - 48 * 60 * 60 * 1000; // 48h
      updatedProjects = updatedProjects.filter(
        (p) =>
          p.status !== 'Terminé' &&
          p.cameras?.some((c) => {
            if (!c.lastPhoto?.createdAt) return false;
            const t = new Date(c.lastPhoto.createdAt).getTime();
            const okRecurrence = c.apiFetchInterval !== -1 || c.optic === '4624x3472' || c.optic === '5496x3672';
            return okRecurrence && t < threshold;
          })
      );
    }

    // Tri (comme avant)
    this.onSortChange(this.sort);

    this.projects = [...updatedProjects];
    await this.$nextTick();

    if (!this.showMap) return;

    // 🔑 si on demande un recentrage (recherche), on fit ;
    // sinon on ne recadre pas (sauf premier affichage sans bounds)
    if (opts.recenter) {
      this.fitToCurrentProjects();
    } else if (!this.mapBounds) {
      this.fitToCurrentProjects();
    }
  }

  public get isSmallScreen(): boolean {
    return window.innerWidth < 500;
  }

  private toDate(input: any): Date | null {
    if (input === null || input === undefined || input === '') return null;

    // Date déjà OK
    if (input instanceof Date) {
      return Number.isNaN(input.getTime()) ? null : input;
    }

    // Timestamp number (ms ou s)
    if (typeof input === 'number') {
      const ms = input < 1e12 ? input * 1000 : input; // heuristique seconds -> ms
      const d = new Date(ms);
      return Number.isNaN(d.getTime()) ? null : d;
    }

    // String : timestamp / DD/MM/YYYY / ISO
    if (typeof input === 'string') {
      const s = input.trim();
      if (!s) return null;

      // string numérique => timestamp
      if (/^\d+$/.test(s)) {
        const n = Number(s);
        const ms = n < 1e12 ? n * 1000 : n;
        const d = new Date(ms);
        return Number.isNaN(d.getTime()) ? null : d;
      }

      // format FR "DD / MM / YYYY"
      const m = s.match(/^(\d{2})\s*\/\s*(\d{2})\s*\/\s*(\d{4})/);
      if (m) {
        const dd = Number(m[1]);
        const mm = Number(m[2]);
        const yyyy = Number(m[3]);
        const d = new Date(yyyy, mm - 1, dd);
        return Number.isNaN(d.getTime()) ? null : d;
      }

      // ISO "2026-02-07T13:47:00.000Z" (ou autre parseable)
      const d = new Date(s);
      return Number.isNaN(d.getTime()) ? null : d;
    }

    // fallback objets/valeurs diverses
    const d = new Date(input);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  private formatDateFR(input: any, withTime = false): string {
    const d = this.toDate(input);
    if (!d) return '—';

    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();

    if (!withTime) return `${day} / ${month} / ${year}`;

    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    return `${day} / ${month} / ${year} - ${hours}:${minutes}`;
  }

  private projectMatchesSelectedTypes(p: Project): boolean {
    // Si aucun type coché → aucun projet
    if (!this.selectedTypes || this.selectedTypes.length === 0) return false;

    const hasIA = this.selectedTypes.includes('IA');
    const hasLive = this.selectedTypes.includes('Live');
    const hasTout = this.selectedTypes.includes('Tout');

    const hasIaCam = p.cameras?.some((cam) => cam.detectionia === true) === true;
    const hasLiveCam = p.cameras?.some((cam) => cam.live === true) === true;
    const isBasic = !hasIaCam && !hasLiveCam;

    const selectedCount = [hasTout, hasIA, hasLive].filter(Boolean).length;

    if (selectedCount === 3) return true; // Tous
    if (selectedCount === 1 && hasTout) return isBasic; // Basic uniquement
    if (selectedCount === 1 && hasIA) return hasIaCam; // IA uniquement
    if (selectedCount === 1 && hasLive) return hasLiveCam; // Live uniquement
    if (selectedCount === 2 && hasIA && hasLive) return hasIaCam && hasLiveCam; // IA & Live
    if (selectedCount === 2 && hasTout && hasLive) return !hasIaCam; // Tout (Basic) & Live → pas IA
    if (selectedCount === 2 && hasTout && hasIA) return !hasLiveCam; // Tout (Basic) & IA → pas Live

    return false;
  }

  @Watch('filterStatus')
  private onFilterStatusWatch() {
    this.updateProjectsAndMap();
  }

  @Watch('imageUrls', { deep: true, immediate: true })
  onImageUrlsChange() {
    this.$forceUpdate();
  }

  @Watch('selectedTypes', { deep: true })
  private onSelectedTypesWatch() {
    this.updateProjectsAndMap();
    if (this.showMap) this.resetSidebarList();
  }

  @Watch('search')
  private onSearchChange() {
    this.onSortChange(this.sort);
    this.resetDisplayedProjectsCount();

    const mustRecenter = this.showMap && this.search.trim().length > 0;
    this.updateProjectsAndMap({ recenter: mustRecenter });
    if (this.showMap) this.resetSidebarList();
  }

  @Watch('allProject')
  private onAllProjectChange(val: Project[], oldVal: Project[]) {
    this.onSearchChange();
    this.resetDisplayedProjectsCount();
    this.updateProjectsAndMap();
  }

  @Watch('projects')
  private onProjectsChange() {
    if (!this.showMap || !this.mapBounds) {
      this.calculateMapBounds();
    }
  }

  @Watch('showMap')
  private async onShowMapChange(val: boolean) {
    if (val) {
      await this.$nextTick();
      if (!this.mapBounds) this.calculateMapBounds();
      this.resetSidebarList();
      this.addCustomZoom(); // ⬅️ ajoute le contrôle
    } else {
      this.destroySidebarIO();
      this.customZoom?.remove(); // ⬅️ nettoie
      this.customZoom = undefined;
    }
  }

  private switchToListMode() {
    this.listMode = 'list';
  }

  private switchToGridMode() {
    this.listMode = 'mosaic';
  }

  private onSortChange(value: SortType) {
    if (value === SortType.Recent) {
      this.projects = this.projects.sort((a: Project, b: Project) => {
        return b.createdAt.getTime() - a.createdAt.getTime();
      });
    } else {
      this.projects = this.projects.sort((a: Project, b: Project) => {
        if (a.city?.name !== undefined && b.city?.name !== undefined) {
          return a.city.name.localeCompare(b.city.name);
        } else if (a.city !== undefined) {
          return -1;
        } else if (b.city !== undefined) {
          return 1;
        } else {
          return 0;
        }
      });
    }
  }

  private isAdmin(project: Project) {
    return (
      this.user !== undefined &&
      (project?.owner?.id === this.user?.id || project.administratorId.includes(this.user.id))
    );
  }

  public viewProject(project: Project) {
    // Naviguer vers la page correspondant au projet dans un nouvel onglet
    const route = this.$router.resolve({ name: 'plateformcentral', params: { id: project.id } });
    window.open(route.href, '_blank');
  }

  private async calculateMapBounds() {
    if (this.projects.length === 0) return;

    const latlngs = this.projects.map((p) => [p.city.latlng.lat, p.city.latlng.lng] as [number, number]);
    const bounds = L.latLngBounds(latlngs).pad(0.1);
    this.center = [bounds.getCenter().lat, bounds.getCenter().lng];
    this.mapBounds = bounds; // 🔑

    const mapRef: any = this.$refs.map;
    const map = mapRef?.mapObject || mapRef;
    if (map && typeof map.fitBounds === 'function') {
      map.fitBounds(bounds);
    }
  }

  private toggleSatelliteView() {
    this.satelliteView = !this.satelliteView;
    if (this.satelliteView) {
      this.url = 'http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}';
    } else {
      this.url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
    }
  }
}
